import styled from "@emotion/styled";

// See https://github.com/philipwalton/flexbugs#flexbug-3
export const IE11Flexbug3Fix = styled("div")`
    display: flex;
    flex-direction: column;
`;
